export default __webpack_public_path__ + "static/media/iphoneseven1.85a500d7.gif";